module.exports = __webpack_public_path__ + "src/img/artist/work03_3.jpg?96d9a8a091035666ec902e98b36ee0f1";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work03_3.jpg
// module id = 152
// module chunks = 0